import React from "react";

const iconProps = {
  width: 88,
  height: 88,
  viewBox: "0 0 88 88",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": true,
};

export const WhyClockIcon = ({ className = "" }) => (
  <svg className={className} {...iconProps}>
    <path
      d="M64.7969 18.2188C64.7969 21.0664 62.4883 23.375 59.6406 23.375C56.793 23.375 54.4844 21.0664 54.4844 18.2188C54.4844 15.3711 56.793 13.0625 59.6406 13.0625C62.4883 13.0625 64.7969 15.3711 64.7969 18.2188Z"
      stroke="#2F548C"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M85.4219 49.1562C85.4219 63.3949 73.8793 74.9375 59.6406 74.9375C45.402 74.9375 33.8594 63.3949 33.8594 49.1562C33.8594 34.9176 45.402 23.375 59.6406 23.375C73.8793 23.375 85.4219 34.9176 85.4219 49.1562Z"
      fill="#2F548C"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8906 30.0439H23.5469"
      stroke="#2F548C"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8906 57.2002H23.5469"
      stroke="#2F548C"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.57812 44H23.5469"
      stroke="#2F548C"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.6406 23.375V28.5312"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.6406 69.7812V74.9375"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.8594 49.1562H39.0156"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M80.2656 49.1562H85.4219"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M59.6406 38.8438V49.1562H69.9531"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhyCertificateIcon = ({ className = "" }) => (
  <svg className={className} {...iconProps}>
    <path
      d="M61.5978 72.5996H64.8975C67.9224 72.5996 70.3974 70.1248 70.3974 67.0997V28.6L52.7974 11.0001H23.0975C20.0725 11.0001 17.5977 13.4753 17.5977 16.5V67.0997C17.5977 70.1248 20.0725 72.5996 23.0975 72.5996H48.3976"
      fill="#2F548C"
    />
    <path
      d="M61.5978 72.5996H64.8975C67.9224 72.5996 70.3974 70.1248 70.3974 67.0997V28.6L52.7974 11.0001H23.0975C20.0725 11.0001 17.5977 13.4753 17.5977 16.5V67.0997C17.5977 70.1248 20.0725 72.5996 23.0975 72.5996H48.3976"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3984 63.7998H39.5984"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3984 55H39.5984"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3984 46.2002H42.8984"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.3984 37.4004H57.1984"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.5984 28.6001H26.3984"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39.5984 19.8003H26.3984"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.5981 57.2001V77L54.9983 72.5998L48.3984 77V57.2001"
      fill="#2F548C"
    />
    <path
      d="M61.5981 57.2001V77L54.9983 72.5998L48.3984 77V57.2001"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.7988 11.6602V23.1002C52.7988 26.1252 55.2737 28.6001 58.2987 28.6001H69.7387"
      fill="#2F548C"
    />
    <path
      d="M52.7988 11.6602V23.1002C52.7988 26.1252 55.2737 28.6001 58.2987 28.6001H69.7387"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M61.5981 57.2C61.5981 60.8449 58.6432 63.7998 54.9983 63.7998C51.3531 63.7998 48.3984 60.8449 48.3984 57.2C48.3984 53.5548 51.3531 50.5999 54.9983 50.5999C58.6432 50.5999 61.5981 53.5548 61.5981 57.2Z"
      fill="#2F548C"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const WhyInfinityIcon = ({ className = "" }) => (
  <svg className={className} {...iconProps}>
    <path
      d="M26.3265 25.6665C16.4315 25.6665 8.41016 33.6879 8.41016 43.5827C8.41016 53.8954 16.8478 62.3331 27.1605 62.3331H27.2583C32.01 62.3331 36.5671 59.6115 39.927 56.2516L43.9882 52.1904L47.6661 56.1869C51.2712 60.1043 56.3516 62.3332 61.6754 62.3332C71.5704 62.3332 79.5917 54.3118 79.5917 44.4168C79.5917 34.1042 71.154 25.6665 60.8414 25.6665H60.7436C55.9919 25.6665 51.4348 28.3879 48.0749 31.748L44.0137 35.8092L40.3358 31.8126C36.7307 27.8954 31.6503 25.6665 26.3265 25.6665Z"
      fill="#2F548C"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.9883 52.1898L56.7911 39.9166C58.093 38.6146 59.8589 37.8832 61.7 37.8832C65.3139 37.7762 68.4058 40.7564 68.4032 44.4161"
      fill="#FAF9F8"
    />
    <path
      d="M43.9883 52.1898L56.7911 39.9166C58.093 38.6146 59.8589 37.8832 61.7 37.8832C65.3139 37.7762 68.4058 40.7564 68.4032 44.4161"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M52.2812 44.2388L56.791 48.7655C58.0929 50.0674 59.8587 50.7989 61.6998 50.7989C65.3137 50.9058 68.4057 47.9256 68.403 44.2659"
      fill="#FAF9F8"
    />
    <path
      d="M52.2812 44.2388L56.791 48.7655C58.0929 50.0674 59.8587 50.7989 61.6998 50.7989C65.3137 50.9058 68.4057 47.9256 68.403 44.2659"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.0145 35.8096L31.2117 48.0828C29.9097 49.3848 28.1439 50.1162 26.3028 50.1162C22.6889 50.2231 19.597 47.243 19.5996 43.5833"
      fill="#FAF9F8"
    />
    <path
      d="M44.0145 35.8096L31.2117 48.0828C29.9097 49.3848 28.1439 50.1162 26.3028 50.1162C22.6889 50.2231 19.597 47.243 19.5996 43.5833"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.7214 43.7606L31.2117 39.2339C29.9097 37.932 28.1439 37.2005 26.3028 37.2005C22.6889 37.0936 19.597 40.0738 19.5996 43.7335"
      fill="#FAF9F8"
    />
    <path
      d="M35.7214 43.7606L31.2117 39.2339C29.9097 37.932 28.1439 37.2005 26.3028 37.2005C22.6889 37.0936 19.597 40.0738 19.5996 43.7335"
      stroke="#FAF9F8"
      strokeWidth="2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ICON_MAP = {
  clock: WhyClockIcon,
  certificate: WhyCertificateIcon,
  infinity: WhyInfinityIcon,
};

export const WhyFeatureIcon = ({ name, className = "" }) => {
  const Icon = ICON_MAP[name];
  if (!Icon) return null;
  return <Icon className={className} />;
};
